import {Component} from '@angular/core';
import {TranslocoService} from "@ngneat/transloco";
import {Compbaser} from "../../../components/compbaser";
import {IUser} from "../../../interfaces";
import {AppService, StoreSelectorsService} from "../../../services";
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'app-prices-pop',
    templateUrl: './prices.component.html',
    styleUrls: ['./prices.component.scss']
})
export class PricesComponent extends Compbaser {
    m_user: IUser;
    m_viewOnly = false;
    constructor(private route: ActivatedRoute,
                private appService: AppService,
                public storeSelector: StoreSelectorsService) {
        super();

        if (this.route.snapshot?.data?.title) {
            if (route.snapshot.data.title === 'Prices') {
                this.m_viewOnly = true;
            }
        }

        this.cod(
            storeSelector.getUser()
                .subscribe((user: IUser) => {
                    this.m_user = user;
                })
        );
    }
}

